<template>
  <div class="text-main">
    <!-- <p class="title">小睡眠隐私政策</p>
    <div class="block">
      <p class="two-title">我们非常重视您的隐私权。</p>
      <p class="common-p">
        广州心与潮信息科技有限公司（以下简称：心潮科技）
        致力于保护用户隐私权。本隐私权政策旨在向您说明，在使用我们的服务时，我们如何收集、存储、使用和管理这些信息。这些信息包括您向我们提供的个人信息或者我们通过我们网站或者移动应用终端收集到的相关信息。收集途径主要包括：移动设备上（如：苹果设备和安卓设备）提供的心潮科技应用程序产品(“我们的服务”)。 使用我们的服务就意味着您同意本政策，并同意根据本政策中规定的方式对您的数据（包括您的个人信息）进行收集和处理。如果您不同意本政策及未来修订版本的任何条款，请不要使用服务。
        如对本政策或任何隐私权相关问题有任何疑问，请通过office@heartide.com与我们联系。
      </p>
    </div>
    <div class="block">
      <p class="two-title">我们可能收集的信息</p>
      <p class="common-p">
        为了向您提供更好的服务，我们将在法律允许的范围内和当且仅当您使用某些功能或者服务时，收集您的相关数据和信息。
      </p>
    </div>
    <div class="block">
      <p class="two-title">您使用服务时我们获取的信息</p>
      <p class="two-title">设备信息</p>
      <p class="common-p">
        当您在移动平台上使用任何心潮科技应用程序时，我们可能收集并记录某些信息，比如您的产品唯一身份标识（持续的／间断的）、硬件种类、介质访问控制（“MAC”）地址、您的操作系统（“OS”）版本、您设备的名称和您的位置（基于您的网络协议（“IP”）地址）。这一信息有助于我们解决问题并了解总体用户使用倾向。<br/><br/>
        我们可能收集您的位置信息以向您提供正确的应用程序版本及更优质的服务。除本政策另有约定外，我们不会与任何第三方分享这一信息。如果您不再希望我们跟踪或使用这一信息，您可以在设备上关闭网络、GPS功能或者禁用我们获取您网络、GPS、设备信息权限。<br/><br/>
        此外，我们可能创建了唯一用户身份标识以跟踪您对我们服务的使用。此唯一用户身份标识与您的个人资料信息储存在一起，以便于了解您正在使用的心潮科技应用程序。
      </p><br/>

      <p class="two-title">数据共享与披露</p>
      <p class="common-p">
        我们的小程序集成友盟+SDK，友盟+SDK需要收集您在小程序平台去标识化ID（如openid/unionid/userid）以及您设置的公开信息（昵称/头像/性别/地区/语言）以提供统计分析服务。
      </p><br/>

      <p class="two-title">使用日志</p>
      <p class="common-p">当您使用我们的服务，包括参与、生成、浏览与我们的服务相关的内容时，我们将会自动收集心潮科技应用内某些相关的日志信息，这些信息包括：(1)关于您的使用时间、使用频率等细节；(2)设备统计信息、关键操作路径、错误日志、崩溃记录、语言和时区等。这些日志信息能够帮助我们更好的了解和改善我们的服务，并非用于识别任何特定的个人。</p><br/>
      <p class="two-title">我们如何使用信息</p>
      <p class="common-p">我们收集用户信息是以提升服务质量与用户体验为目的，为了实现这一目的，我们可能将您的信息用于：</p>
      <p class="two-title">(一) 创建帐号；</p>
      <p class="two-title">(二) 运营及改善我们的服务；</p>
      <p class="two-title">(三) 回复您的评论与问题，并提供客户服务；</p>
      <p class="two-title">(四) 提供及交付您要求的产品与服务；</p>
      <p class="two-title">(五) 发送与您相关的信息，包括确认、技术通告、更新、安全警告、支持及行政信息；</p>
      <p class="two-title">(六) 为上述目的，在其他国家处理您的信息。</p><br/>
      <p class="common-p">除非下列情形发生时，我们无权披露您的全部或部分信息：</p>
      <p class="two-title">(一) 为保护他人的人身或财产安全；</p>
      <p class="two-title">(二) 为防止或解决网络欺诈；</p>
      <p class="two-title">(三) 维护心潮科技的合法权利及权益;</p>
      <p class="two-title">(四) 实现“我们可能收集的信息”部分所述目的，前提条件为该等披露接收方应同等接受本政策约束并可以提供信息充分保护；</p>
      <p class="two-title">(五) 根据法律、法规的规定，或遵从政府部门、司法机关的要求；通常前述要求都是为了保护网络安全和保护我们、我们的用户和第三方的权利、财产和安全。</p>
      <p class="two-title">(六) 为上述目的，在其他国家处理您的信息。</p>
      <p class="common-p">除非下列情形发生时，我们无权披露您的全部或部分信息：</p>
      <p class="two-title">(一) 为保护他人的人身或财产安全；</p>
      <p class="two-title">(二) 为防止或解决网络欺诈；</p>
      <p class="two-title">(三) 维护心潮科技的合法权利及权益;</p>
      <p class="two-title">(四) 实现“我们可能收集的信息”部分所述目的，前提条件为该等披露接收方应同等接受本政策约束并可以提供信息充分保护；</p>
      <p class="two-title">(五) 根据法律、法规的规定，或遵从政府部门、司法机关的要求；通常前述要求都是为了保护网络安全和保护我们、我们的用户和第三方的权利、财产和安全。</p>
    </div>
    <div class="block">
      <p class="two-title">信息安全性</p>
      <p class="common-p">我们使用合理措施，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术来保护您提供的个人信息。但请您理解（在互联网行业）即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。</p>
    </div>
    <div class="block">
      <p class="two-title">信息访问与控制</p>
      <p class="common-p">
        我们将采取一切合理适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障帐号安全。      </p>

    </div>
    <div class="block">
      <p class="two-title">数据保留</p>
      <p class="common-p">
        受限于法律法规要求，我们将按照“我们如何使用信息”章节或者为您提供服务的时间范围内保留您的信息。如果您希望删除您的帐号或者要求我们不得再使用您的信息为您提供服务，请发送电子邮件至office@heartide.com。      </p>
    </div>
    <div class="block">
      <p class="two-title">儿童信息</p>
      <p class="common-p">
        我们不会有意向13周岁以下的人群收集或请求个人信息。如果您低于13周岁，请不要向我们发送您的个人信息，包括您的名字、地址、电话号码或者邮箱地址。如果您认为我们可能有13周岁以下儿童任何信息时，请发送电子邮件至office@heartide.com。      </p>
    </div>
    <div class="block">
      <p class="common-p" style="text-align: right">广州心与潮信息科技有限公司</p>
      <p class="common-p" style="text-align: right">更新日期：2020年11月05日</p>
    </div> -->
            <h2 class="center">隐私信息保护政策</h2>
        <p>发布时间：2020年11月05日</p>
        <p>生效时间：2020年11月05日</p>
        <p>更新时间：2023年07月20日</p>
        <h3 class="mt50">我们非常重视您的隐私权</h3>
        <p>广州心与潮信息科技有限公司（以下简称：“心潮科技”）尊重并保护所有使用小睡眠移动客户端的用户（以下称为“您”）个人隐私与信息安全。鉴于此，心潮科技制定《小睡眠隐私信息保护政策》（以下称为“本政策”）与您确认关于您在使用小睡眠移动客户端期间，心潮科技将收集、存储、使用、管理和保护您的个人信息的相关事宜。在使用小睡眠移动客户端前，请您务必仔细阅读并透彻理解本政策，特别是以粗体/粗体下划线标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。在此过程中，如果您有任何疑问、意见或建议，您可通过心潮科技提供的各种联系方式与我们取得联系，我们会尽快为您作出解答。</p>
        <h3>一、心潮科技公司如何收集您的个人信息</h3>
        <p>您在使用我们的产品或服务时，我们需要/可能需要收集和使用您的相关个人信息；用以向您提供服务、优化我们的服务以及保障您的账户安全。</p>
        <h3>（一）小睡眠移动客户端所收集的信息</h3>
        <h3>1. 服务内容展示/浏览/播放/下载功能</h3>
        <p><span class="fwb">收集目的：</span>为保障您正常使用我们的<span class="fwb">服务内容展示/浏览/播放/下载功能</span>，维护我们服务的正常运行，了解产品对不同硬件设备适配性、确保操作环境安全、识别帐号异常状态用途。</p>
        <p><span class="fwb">收集方式及范围：</span>我们根据合法、正当、必要的原则，收集实现产品功能所必要的信息。您在软件安装或使用中同意授权隐私政策之后，收集您的<span class="fwb">设备序列号、设备型号、操作系统、唯一设备标识符、登录IP地址、操作日志、MAC地址、匿名设备标识符(OAID)。</span></p>
        <p>我方客户端收集您的设备信息的频次与时机是<span class="fwb">仅在您启动客户端时执行一次，且当客户端处于后台运行状态时，不会再次收集您的设备信息。</span></p>
        <p>我们收集这些信息是为了向您提供我们最核心的服务内容展示/播放/下载服务，如您拒绝提供上述信息或权限将可能导致您无法使用我们的产品与服务。请您知悉，单独的设备信息、日志信息无法识别您的身份信息。</p>
        <h3>2. 日志信息</h3>
        <p>当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存，用于帮助我们优化产品服务。包括您的搜索和浏览记录、关注、播放记录、访问量、播放时长、IP地址、WiFi网络、使用的语言、访问日期和时间。</p>
        <h3>3. 创建帐号功能</h3>
        <p>当您在我方客户端创建帐号时，我们会收集由您主动提供给我们的一些单独或者结合识别您实名身份的信息，包括：<span class="fwb">手机号码</span>、用户名。我们收集这些信息是用以完成注册程序、为您持续稳定提供专属于注册用户的产品或服务，并保护您的帐号安全。您应知悉，手机号码和验证码匹配结果属于您的个人敏感信息，我们收集该类信息是为了满足相关法律法规的要求，如您拒绝提供可能导致您无法使用我们的此功能，请您谨慎考虑后再提供。</p>
        <h3>4. 第三方帐号信息</h3>
        <p>您使用第三方平台的帐号<span class="fwb">（微信帐号、微博帐号、QQ帐号）</span>登录时，如果您决定绑定小睡眠帐号，经过您的帐号绑定授权，第三方平台会同步一部分信息给我方，如头像、昵称或ID。我们收集这些信息是用于为您提供帐号登录服务以及保障您的帐号安全，防范安全风险。如您拒绝授权此类信息的，您将无法使用第三方 平台的帐号登录我们平台，但不影响我们为您提供的其他产品和服务的正常使用。</p>
        <h3>5. 基本资料维护&身份验证</h3>
        <p>【基本信息维护】您在使用我方客户端时，为维护您的基本资料，改善您的服务体验，需要您选择填写及/或完善服务必要的信息，可能包括您的头像、昵称。如您不提供这些信息，并不影响您对我方客户端核心功能使用。</p>
        <p><span class="fwb">【身份验证】</span>如果您的帐号遗失，我们将提供两种方式验证您的身份，如手机身份验证，或通过客服方式找回，在此过程中需您提供一些信息以验证您的身份。<span class="fwb">在找回帐号时，我方可能需要您提供经常登录设备、经常收听内容 、注册时间，必要时需要提供支付订单凭证。</span></p>
        <h3>6. 为您提供VIP会员或订阅服务</h3>
        <p>为完成VIP会员费用支付，我们会记录您的支付方式和资金帐号，以实现原路径退款、活动红包提现、解除连续订阅会员服务、售后服务。我们会根据您选择的支付方式把您的订单支付相关信息、订单安全相关设备信息及其他反洗钱法律要求的必要信息通过在应用程序中嵌入的支付宝以及其他第三方支付的软件工具开发包（SDK）的方式与支付宝公司或其他第三方支付公司共享。同时，我们会记录并向您展示您帐号的订单信息，包括购买会员、睡贝充值信息。</p>
        <h3>7. 客户服务及争议处理</h3>
        <p>为向您提供客户服务，我们会记录您提供的联系方式和通信/通话记录和内容，用于与您联系和帮助您解决问题，或记录相关问题的处理方案及结果。</p>
        <p>为确认交易状态及为您提供会员VIP售后与争议解决服务，我们会通过您基于交易所选择的支付机构、支付方式收集与交易相关的<span class="fwb">您的交易、支付信息。</span></p>
        <h3>8. 安全保障功能</h3>
        <p>我们需要收集您的设备信息来保障您使用我们的产品或服务时的帐号与系统安全，并协助提升我们的产品服务的安全性和可靠性，以防产生任何危害用户、心潮科技、社会的行为，包括您的如下<span class="fwb">个人信息：个人常用设备信息（包含：硬件型号、设备MAC地址、IMEI、IMSI）、 登录IP地址、产品版本号、浏览记录、服务故障信息，以及个人敏感信息：手机号码、交易信息</span>。我们会根据上述信息来综合判断您帐号及交易风险、进行身份验证、客户服务、检测及防范安全事件、诈骗监测、存档和备份用途，并依法采取必要的记录、审计、分析、处置措施。一旦我们检测出存在或疑似存在帐号安全风险时，我们会使用相关信息进行安全验证与风险排除，确保我们向您提供的产品和服务的安全性，以用来保障您的权益不受侵害。同时，当发生帐号或系统安全问题时，我们会收集这些信息来优化我们的产品和服务。</p>
        <!-- <h3>9. 消息通知与定向推送</h3>
        <p>基于您向我们提供的信息、我们可能收集的信息及我们通过间接方式收集到的您的信息，例如您的浏览、搜索及播放记录、设备信息、位置信息、订单信息，我们可能会基于上述一项或几项信息的结合，进行推荐算法建模、程序化广告推荐算法建模、用户行为分析及用户画像，用于提取您的浏览、搜索偏好、行为习惯、位置信息相关特征，以便向您提供更契合您需求的页面展示和推荐个性化内容。</p> -->
        <h3>（二）第三方 SDK 所收集的信息</h3>
        <p><span class="fwb">您授权同意</span>我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能，我们仅会出于本隐私信息保护政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到为其履行职责所需信息，且不得将此信息用于其他任何目的。</p>
        <p>我们的产品以集成 SDK 的方式，实现如下服务类型：</p>
        <h3>1. 数据统计、数据分析服务</h3>
        <p class="fwb">我们的产品集成友盟+SDK，友盟+SDK需要收集您的设备Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力。</p>
        <h3>2. 崩溃、故障信息统计服务</h3>
        <p>我们的产品集成腾讯 Bugly SDK，需要读取您的设备标识符，WiFi地址，运营商信息，用于提供崩溃日志上报、热修复、版本更新推送的服务。</p>
        <h3>3. 客服反馈服务</h3>
        <p>我们会向客服供应商、服务商（如腾讯兔小巢）提供您的用户昵称、设备识别号，以便支持我们进行相关的客户服务、售后服务，提升服务体验。</p>
        <p>我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。</p>
        <p>提供技术服务的第三方SDK提供商。关于提供商的身份、收集个人信息的目的、方式、范围情况，请您详细参见本政策附件一、二。</p>
        <h3>（三）其他</h3>
        <p class="fwb">1．若您提供的信息中含有其他用户的个人信息，在向我们提供这些个人信息之前，您需确保您已经取得合法的授权。若其中涉及儿童个人信息的，您需在发布前取得对应儿童监护人的同意，前述情形下监护人有权通过本政策第九条的途径联系我们，要求更正或删除涉及儿童个人信息的内容。</p>
        <p class="fwb">2．若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的个人信息，均会事先获得您的同意。</p>
        <p>若我们从第三方处间接获取您的信息的，我们会在收集前明确以书面形式要求该第三方在已依法取得您同意后收集个人信息，并向您告知共享的信息内容，且涉及敏感信息的在提供给我们使用前需经过您的明确确认，要求第三方对个人信息来源的合法性和合规性作出承诺，如第三方有违反行为的，我们会明确要求对方承担相应法律责任；同时，我们的专业安全团队对个人信息会进行安全加固（包括敏感信息报备、敏感信息加密存储、访问权限控制）。我们会使用不低于我们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。</p>
        <h3>3. 征得授权同意的例外</h3>
        <p>您充分理解并同意，我们在以下情况下收集、使用您的个人信息无需您的授权同意，且我们可能不会响应您提出的更正/修改、删除、注销、撤回同意、索取信息的请求：</p>
        <p>(1) 与国家安全、国防安全有关的；</p>
        <p>(2) 与公共安全、公共卫生、重大公共利益有关的；</p>
        <p>(3) 与犯罪侦查、起诉、审判和判决执行司法或行政执法有关的；</p>
        <p>(4) 出于维护您或其他个人的生命、财产重大合法权益但又很难得到本人同意的；</p>
        <p>(5) 您自行向社会公众公开的个人信息；</p>
        <p>(6) 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开渠道。</p>
        <p>(7) 根据与您签订和履行相关协议或其他书面文件所必需的；</p>
        <p>(8) 用于维护所提供的产品及/或服务的安全稳定运行所必需的，例如发现、处置产品及/或服务的故障；</p>
        <p>(9) 为合法的新闻报道所必需的；</p>
        <p>(10) 学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
        <p>(11) 法律法规规定的其他情形。</p>
        <h3>二、心潮科技公司如何使用Cookie以及同类技术</h3>
        <p>Cookie 和同类技术是互联网中普遍使用的技术。当您使用我方客户端相关服务时，我们可能会使用相关技术收集您的信息。我们使用 Cookie 和 同类技术主要为了实现以下功能或服务</p>
        <p class="fbw">（一）保障产品与服务的安全、高效运转</p>
        <p>我们可能会设置认证与保障安全性的 Cookie 或匿名标识符，使我们确认您是否安全登录服务，或者 是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。</p>
        <p class="fbw">（二）帮助您获得更轻松的访问体验</p>
        <p>使用此类技术可以帮助您省去重复您填写个人信息、输入搜索内容的步骤和流程（例如：表单填写）。</p>
        <p>您可以通过浏览器设置拒绝或管理Cookie以及同类技术的使用；但请注意，如果停用Cookie，您可能无法享受最佳的服务体验，某些服务也可能无法正常使用。</p>
        <h3>三、心潮科技公司如何使用、转移、披露您的个人信息</h3>
        <p class="fwb">（一）共享和披露</p>
        <p>除下列情形外，我们不会与任何其他第三方共享您的个人信息。</p>
        <p><span class="fwb">1. 在获得您的明确同意或授权或您主动选择的情况下共享。</span>获得您的明示授权或明确同意后，我们会与其他公司、组织和个人分享您的个人信息。例如，如果我们委托第三方向您提供产品或服务（如产品寄送、用户活动、礼品赠送时），我们会在征得您明示同意后将上述信息共享给第三方，如果您拒绝提供此类信息，我们将无法完成相关交付服务。只有您选择同意，我们才会共享您的个人敏感信息。获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息。</p>
        <p><span class="fwb">2. 在法定情形下的共享和披露。</span>我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。例如，如果我们确定您出现违反法律法规或严重违反我方相关协议规则的情况，或为保护我方客户端及用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或我方客户端相关协议规则，在征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及我方平台已对您采取的措施。例如，若您或您使用的帐号发布非法言论、而严重违反我方规则、触犯法律法规和/或违背公序良俗，造成重大社会影响，给我方造成声誉损失，我们可能会披露您的信息与处罚情况。</p>
        <p><span class="fwb">3. 向我方的关联方分享您的个人信息。</span>与关联公司间共享：为便于我们基于关联帐号共同向您提供服务，或保护我方关联公司或其他用户或公众的人身财产安全免遭侵害，在经过您的授权同意后，您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息（如为便于您使用我方帐号登录并使用我们关联公司产品或服务，我们会向关联公司共享您必要的个人信息），且受本隐私信息保护政策中所声明目的的约束。如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的明示授权同意。</p>
        <p><span class="fwb">4. 协助处理争议。</span>如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷。只有共享您的信息，才能提供您需要的服务，或处理您与他人的纠纷或争议。如交易任何投诉一方、司法机构或行政执法机构提出信息披露请求的，我方会视情况向该上述机构提供被投诉用户的联络方式及个人必要信息，以促成交纠纷的解决。我方平台仅在法律有明确规定的情况下承担相应的法律责任。</p>
        <p><span class="fwb">5. 提供和改进产品和服务。</span>为了进一步完善产品或服务，提供更优质的用户体验，心潮科技公司将使用您提供的信息自行或提供给数据服务商进行数据统计、分析，以评估、维护和改进心潮科技公司产品或服务的性能。</p>
        <p class="fwb">这些信息在使用前会经过匿名化处理的，将不会包含您的任何身份识别信息。</p>
        <p><span class="fwb">6. 数据转移。</span>若心潮科技公司发生重组、合并、分立、清算或资产出售时，您的信息将作为交易标的转移到新的主体，在本政策变更前，您的个人信息仍然受到本个人信息保护政策的保护。</p>
        <p class="fwb">（二）转让</p>
        <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
        <p>1. 在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
        <p>2.在我方服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</p>
        <p class="fwb">（三）共享、转让、披露个人信息时事先征得授权同意的例外</p>
        <p>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
        <p>1.与国家安全、国防安全有关的；</p>
        <p>2.与公共安全、公共卫生、重大公共利益有关的；</p>
        <p>3.与犯罪侦查、起诉、审判和判决执行有关的；</p>
        <p>4.出于维护您或其他个人的生命、财产重大合法权益但又很难得到本人同意的；</p>
        <p>5.您自行向社会公众公开的个人信息；</p>
        <p>6.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开渠道。</p>
        <p>根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>
        <p class="fwb">如您不同意我们按照上述条款向第三方提供您的个人信息，请您立即停止使用我方客户端服务。</p>
        <h3>四、心潮科技公司如何存储信息</h3>
        <p class="fwb">（一）信息存储的地点</p>
        <p>我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：</p>
        <p>1.法律法规有明确规定；</p>
        <p>2.获得您的明确授权；</p>
        <p>针对以上情形，我们会确保依据本隐私权政策对您的个人信息提供足够的保护。</p>
        <p>（二）信息存储期限</p>
        <p>我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求。而我们判断前述期限的标准包括：</p>
        <p class="fwb">1、完成与您相关的服务目的、维护相应服务及业务记录、应对您可能的查询或投诉；</p>
        <p class="fwb">2、保证我们为您提供服务的安全和质量；</p>
        <p class="fwb">3、您是否同意更长的留存期间；</p>
        <p class="fwb">4、是否存在保留期限的其他特别约定。</p>
        <p>在您的个人信息超出保留期限后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。</p>
        <p class="fwb">（三）信息删除和匿名化处理</p>
        <p>如本公司服务决定停止运营，我们将在相关服务停止运营后停止继续收集您的个人信息。我们将以公告形式将停止运营通知向您送达。对已持有的您的个人信息将进行删除或匿名化处理。涉及儿童个人信息的，我们会一并将停止运营的通知及时告知儿童监护人。</p>
        <h3>五、 心潮科技公司如何保护您的个人信息安全</h3>
        <p>为确保我们所收集的您的个人信息安全，我们承诺将努力达到合理的安全水平，现将具体安全措施和安全能力陈述如下：</p>
        <p class="fwb">（一）技术安全防护</p>
        <p>为保障您的信息安全，我们努力采取各种符合业界标准的合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息。</p>

        <p class="fwb">（二）安全体系保证</p>
        <p>我们有行业先进的以数据为核心、围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术方面多维度提升整个系统的安全性。目前，为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入安全风险，更准确地识别违反法律法规或我方客户端相关协议规则的情况，我方平台对系统进行了等级保护。</p>
        <p class="fwb">（三）人员安全管理</p>
        <p>我们对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况以及其他措施。我方会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，我方将尽力做到使您的信息不被泄漏、毁损或丢失。我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</p>
        <p class="fwb">（四）敏感信息及保护提示</p>
        <p><span class="fwb">1. 个人敏感信息保护注意：</span>您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，例如您的头像图片上传，例如您在评论时选择上传包含的个人信息。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。</p>
        <p><span class="fwb">2. 您的帐号均有安全保护功能，请妥善保管您的帐号信息。</span>我方将通过向其它服务器备份、对用户密码进行加密以及其他安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您理解在信息网络上不存在“完善的安全措施”。</p>
        <p class="fwb">（五）信息披露提示及密码泄露处理</p>
        <p>请注意互联网并非绝对安全的环境。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是你的帐号及密码发生泄露，请您立即联络我方客服，以便我方采取相应措施。</p>
        <p class="fwb">（六）信息安全事件处理</p>
        <p>在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。事件相关情况我们将以邮件、电话、推送通知、短消息的方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</p>
        <p class="fwb">（七）儿童个人信息安全</p>
        <p>我们严格设定儿童个人信息访问权限，对可能接触到儿童个人信息的工作人员采取最小够用授权原则，并采取技术措施对工作人员处理儿童个人信息的行为进行记录和管控，避免违法复制、下载儿童个人信息。</p>
        <p>我们已制定儿童个人信息安全事件应急预案，定期组织内部相关人员进行应急响应培训和应急演练，使其掌握岗位职责和应急处置策略和规程。在不幸发生儿童个人信息安全事件后，我们将按照法律法规的要求，及时向儿童及其监护人告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、儿童及其监护人可自主防范和降低风险的建议、对儿童及其监护人的补救措施。我们将及时将事件相关情况以App推送通知、发送邮件/短消息的方式告知儿童及其监护人。难以逐一告知时，我们会采取合理、有效的方式发布相关警示信息。同时，我们还将按照监管部门要求，主动上报儿童个人信息安全事件的处置情况。若儿童及其监护人的合法权益受损，我们将承担相应的法律责任。</p>
        <h3>六、 未成年人保护</h3>
        <p>我们非常重视对未成年人的个人信息保护。如您为未成年人，我们要求您请您的父母或其他监护人仔细阅读本隐私信息保护政策，并在征得您的父母或其他监护人同意的前提下使用我们的服务或向我们提供信息。</p>
        <p>若您是儿童的父母或其他监护人，请您关注您监护的儿童是否是在取得您的授权同意之后使用我们的服务。如您对您所监护的儿童的个人信息有疑问，请通过第九章节中的联系方式与我们联系。</p>
        <h3>七、 您如何管理您的信息</h3>
        <p>我们按《中华人民共和国网络安全法》的要求，通过提供便捷的方法，让您可以访问、更正及删除自己的帐号信息或使用我们的服务时您提供的其他个人信息。您可以通过如下方式访问及管理您的个人信息：</p>
        <p class="fwb">（一）访问您的个人信息</p>
        <p>您有权访问您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的个人信息：</p>
        <p>帐号信息——如果您希望访问或编辑您的帐号中的个人基本资料信息、或注销您的帐号，您可以登录帐号后通过“注销帐号”执行此类操作。</p>
        <p class="fwb">（二）更正或补充您的个人信息</p>
        <p>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正或补充。您可以通过“（一）访问您的个人信息”中列明的方式提出更正或补充申请。</p>
        <p class="fwb">（三）删除您的个人信息</p>
        <p>您可以通过“（一）访问您的个人信息”中列明的方式删除您的部分个人信息。</p>
        <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
        <p class="fwb">1．如果我们处理个人信息的行为违反法律法规；</p>
        <p class="fwb">2．如果我们收集、使用您的个人信息，却未征得您的明确同意；</p>
        <p class="fwb">3．如果我们处理个人信息的行为严重违反了与您的约定；</p>
        <p class="fwb">4．如果您不再使用我们的产品或服务，或您主动注销了帐号；</p>
        <p class="fwb">5．如果我们永久不再为您提供产品或服务</p>
        <p>若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。</p>
        <p>当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>
        <p class="fwb">（四）改变您授权同意的范围</p>
        <p>每个业务功能需要一些基本的个人信息才能得以完成。除此之外，对于额外个人信息的收集和使用，您可以与我方客服联系，给予或收回您的授权同意。</p>
        <p>当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</p>
        <p class="fwb">（五）个人信息主体注销帐号</p>
        <p>现阶段，我方已通过技术方式实现，使您可以自行在“注销帐号”页面（小睡眠移动客户端“我的 - 注销帐号”）提交帐号注销申请。若未能申请成功，您也可联系我方客服。我们在核实用户身份后，会注销您的手机号和使用记录，达到注销的效果。</p>
        <p class="fwb">在您主动注销帐号之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或对其匿名化处理。</p>
        <p class="fwb">（六）约束信息系统自动决策</p>
        <p>在某些业务功能中，我们可能仅依据信息系统、算法在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害我方平台商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。</p>
        <p class="fwb">八、个人信息保护政策的修订</p>
        <p class="fwb">心潮科技公司可能对本政策进行不定期修改，协议修改后，心潮科技公司将在相关页面或以其他合适的方式公布修改的内容。如果您不同意本协议的修改，请立即停止使用平台或取消已经获得的服务；如果您选择在本政策修改后继续访问或使用平台或服务的，则视为您已接受本政策的修改。</p>
        <p>您与心潮科技公司签署的本政策所列明的条款，并不能完全涵盖您与心潮科技公司所有的关于个人信息的权利和义务。因此，<span class="fwb">心潮科技公司公布其他声明、各形式规则均视为本政策之补充条款，为本政策不可分割的组成部分，与本协议具有同等法律效力。</span></p>
        <p>未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。我们会在心潮科技公司专门链接上发布对隐私权政策所做的任何变更和更新。 对于重大变更，我们还会提供更为显著的通知（包括我们会通过我方平台公示的方式进行通知甚至向您提供弹窗提示）。</p>
        <p>本政策所指的重大变更包括但不限于：</p>
        <p>1.我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；</p>
        <p>2.我们在控制权方面发生重大变化。如并购重组引起的所有者变更；</p>
        <p>3.个人信息共享、转让或公开披露的主要对象发生变化；</p>
        <p>4.您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
        <p>5.我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
        <p>6.个人信息安全影响评估报告表明存在高风险时。</p>
        <p>为了您能及时接收到通知，建议您在联系方式更新时及时通知我们。如您在本政策更新生效后继续使用我们的服务，即代表您已充分阅读、理解并接受更新后的政策并愿意受更新后的政策约束。我们鼓励您在每次使用我们服务时都查阅本政策。您可以在小睡眠客户端通过“我的-关于我们-隐私政策”中查看本政策。</p>
        <h3>九、如何联系心潮科技公司</h3>
        <p>您可以通过以下方式与我们联系，我们将在15个工作日内回复您的请求：我们设立了个人信息保护专职部门，如您对心潮科技隐私信息保护政策、儿童个人信息有任何疑问、意见或建议，您可通过以下方式与我们取得联系：</p>
        <p>我方地址：广州市海珠区新滘中路10号之三101、之四101、之五101</p>
        <p>联系人：心潮科技客服部</p>
        <p>联系方式：020-87351934</p>
        <p>联系邮箱：office@heartide.com</p>
        <p>本协议签订地为中华人民共和国广州市海珠区，因本协议生效、履行、解释及使用心潮科技公司服务而产生或与本协议相关的一切争议、权利主张或其他事项，均适用中华人民共和国法律（港澳台地区除外 ）。</p>
        <p>您与心潮科技公司或小睡眠移动客户端发生的一切争议，应友好协商，如协商不成的，可选择按下述任一途径解决：</p>
        <p>（一） 提交仲裁委员会，按照申请仲裁时现行有效的仲裁规则进行仲裁；仲裁裁决为终局裁决，对各方均有约束力；</p>
        <p>（二） 提交协议签订地人民法院诉讼管辖；</p>
        <p>请您再次确认您已全部阅读并充分理解上述条款。</p>
        <p>注：本政策版本更新日期为2023年07月20日，如您认为更新的政策对您更为有利，我们同意双方适用新的政策内容。</p>
        <p class="right">广州心与潮信息科技有限公司</p>
        <p class="right">2023年07月20日</p>
  </div>
</template>

<script>
export default {
  name: 'iosyinsi',
  mounted () {
    document.title = '隐私政策'
  }
}
</script>

<style lang="scss" scoped>
.iosyinsi {
  font-size: px2html(14px);
  box-sizing: border-box;
  margin-top: px2html(20px);
  padding-left: px2html(21px);
  padding-right: px2html(18px);
  .title {
    font-size: px2html(16px);
    font-weight: 900;
    margin-bottom: px2html(28px);
  }
  .block {
    margin-bottom: px2html(28px);
  }
  .two-title {
    font-weight: 700;
    text-align: left;
    margin-bottom: px2html(14px);
  }
  .common-p {
    text-align: left;
    margin-bottom: 7px;
  }
}
</style>
